import m from "./../../../dist/es2015/locales/sl_SL.js";
export const am5locales_sl_SL = m;